import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { credentials } from '../data/profile';
import { downloadResume } from '../utils/resumePdf';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Credentials() {
  return <section aria-label="Credentials" className="w-full border-t border-line bg-white py-20 lg:py-24" data-id="element-235" data-mp="34dql3hy3s6km">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-236" data-mp="2bn8kqoorkjaw">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.3fr_0.7fr] lg:gap-20" data-id="element-237" data-mp="2bnqqcbxbg9vh">
          <Reveal data-id="element-238" data-mp="27mom1gojl7mn">
            <div data-id="element-239" data-mp="27ng92342px1b">
              <SectionLabel data-id="element-240" data-mp="27nzs5n5gmrgx">Credentials</SectionLabel>
              <h2 className="mt-6 font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl" data-id="element-241" data-mp="2lmfvr58101uu">
                Profile at a glance
              </h2>
              <button type="button" onClick={downloadResume} className="mt-8 inline-flex items-center gap-2.5 border border-navy px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-premium hover:bg-navy hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-242" data-mp="ue56ws5r1xj">
                <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="3odpxhu0noz4k" />
                Download Full CV
              </button>
            </div>
          </Reveal>

          <dl className="grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-3" data-id="element-244" data-mp="2vo0rf293a8w3">
            {credentials.map((group, index) => <Reveal key={group.label} delay={index * 0.06} data-id="element-245" data-mp="30mandf2n1dir" data-mpi={index}>
                <div className="border-t-2 border-navy pt-6" data-id="element-246" data-mp="35m6uhn6mtl2j">
                  <dt className="text-[11px] font-semibold uppercase tracking-label text-navy" data-id="element-247" data-mp="35km2o5bpcg8d">
                    {group.label}
                  </dt>
                  <dd data-id="element-248" data-mp="2cy19r0fkvw2p">
                    <ul className="mt-5 space-y-3.5" data-id="element-249" data-mp="2cwggrf8wwl6y">
                      {group.items.map(item => <li key={item} className="border-b border-line pb-3.5 text-[14px] leading-relaxed text-charcoal-light last:border-b-0" data-id="element-250" data-mp="2hvb6701dx801">
                          {item}
                        </li>)}
                    </ul>
                  </dd>
                </div>
              </Reveal>)}
          </dl>
        </div>
      </div>
    </section>;
}